import React, {useEffect, useState} from 'react';
import moment from 'moment';
import './Footer.scss';
import {isInternalLink} from "../../helpers/filters";
import {trackEventByUrl} from "../../helpers/events";
import {twillBase} from "../../config/API";


const Footer = () => {
    const [menuData, setMenuData] = useState([]);

    useEffect(() => {
        fetch(`${twillBase}/api/nav-blocks/Footer`)
            .then((res) => res.json())
            .then((data) => setMenuData(data))
            .catch((err) => console.error("Error fetching menu:", err));
    }, []);

    return (

        <React.Fragment>
            <footer className="site-footer">
                <div className="container">
                    <p className="copyright">&copy; {moment().format('YYYY')} MarketAxess Holdings Inc.</p>

                    {(menuData && menuData.blocks && menuData.blocks.length) ? (
                        <ul>
                            {menuData.blocks.map(link => (
                                link.url !== undefined && (
                                <li key={`${link.url}_${link.label}`} className="legalFooterItem">
                                    {isInternalLink(link.url) && link.url !== '/website-issue' ? (
                                        <a href={link.url}>{link.label}</a>
                                        ) : (
                                        <a onClick={() => trackEventByUrl(link.url, link.label)}
                                    href={link.url}>{link.label}</a>
                                    )}
                                </li>
                                )
                            ))}
                        </ul>
                    ) : null}

                </div>

            </footer>
        </React.Fragment>
    );
}

export default Footer;



// WEBPACK FOOTER //
// ./frontend/components/Footer/Footer.jsx